import type { PrivyClientConfig } from '@privy-io/react-auth';
import { CHAIN_DEFINITIONS, getDefaultChain } from './chains';

export type PrivyConfigOverrides = {
  loginMethods: PrivyClientConfig['loginMethods'];
  appearance?: PrivyClientConfig['appearance'];
  embeddedWallets?: PrivyClientConfig['embeddedWallets'];
  mfaMethods?: PrivyClientConfig['mfaMethods'];
  legal?: PrivyClientConfig['legal'];
};

export function buildPrivyConfig(overrides: PrivyConfigOverrides): PrivyClientConfig {
  // ブラウザ以外（テスト/SSR）では window が無いため相対URLにフォールバック
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  const config: PrivyClientConfig = {
    loginMethods: overrides.loginMethods,
    // ログイン時に利用規約・プライバシーポリシーへの同意リンクを表示（Privyモーダル内）
    legal: overrides.legal ?? {
      termsAndConditionsUrl: `${origin}/terms`,
      privacyPolicyUrl: `${origin}/privacy`,
    },
    appearance: overrides.appearance ?? {
      theme: 'dark',
      accentColor: '#02bbd1',
      logo: '/gifterra-logo.png',
    },
    embeddedWallets: overrides.embeddedWallets ?? {
      createOnLogin: 'off',
      noPromptOnSignature: false,
    },
    defaultChain: getDefaultChain(),
    supportedChains: [CHAIN_DEFINITIONS[137], CHAIN_DEFINITIONS[8217]],
  };

  if (overrides.mfaMethods !== undefined) {
    config.mfaMethods = overrides.mfaMethods;
  }

  return config;
}
